import { useContext } from "react";
import { Layout, Button, Row, Col, Dropdown, Avatar, Space, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { logMixpanelEventBasic, logout } from "./Helpers";
import Logo from "./images/kulcare_logo_black.svg";
import UserContext from "./UserContext";

const { Header } = Layout;

const TopNav = () => {
  const {
    userPhoto,
    userName,
    userLoggedIn,
    setUserPhoto,
    setUserName,
    setUserLoggedIn,
  } = useContext(UserContext);

  const navigateToAuth = () => {
    logMixpanelEventBasic("Signup Initiated");
    window.open(
      `${process.env.REACT_APP_AUTH_URL}/sign-up?utm_source=public_news`,
      "_self"
    );
  };

  const handleMenuClick = (e) => {
    if (e && e.key === "1") {
      handleLogout();
    }
  };

  const handleLogout = () => {
    setUserPhoto(null);
    setUserName("");
    setUserLoggedIn(false);
    logout();
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key={"1"}>Logout</Menu.Item>
    </Menu>
  );
  return (
    <Header className="topNav">
      <Row type="flex" justify="space-between">
        <Col>
          <img src={Logo} alt="Logo" className="kc-logo" />
        </Col>

        <Col>
          <>
            {userLoggedIn ? (
              <Dropdown
                placement="bottomRight"
                overlay={menu}
                onClick={handleMenuClick}
                trigger={["click"]}
              >
                <a href="#" onClick={(e) => e.preventDefault()}>
                  {userPhoto ? (
                    <Avatar size="small" src={userPhoto} />
                  ) : (
                    <Avatar
                      size="small"
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjE1IiBjeT0iMTUiIHI9IjE1Ii8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHVzZSBmaWxsPSIjRkZGIiB4bGluazpocmVmPSIjYSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiIG1hc2s9InVybCgjYikiPjxwYXRoIGZpbGw9IiM1MjVGN0YiIGQ9Ik0xMiAxNC4zMDhhNS4wNzcgNS4wNzcgMCAxIDAgMC0xMC4xNTQgNS4wNzcgNS4wNzcgMCAwIDAgMCAxMC4xNTR6Ii8+PHBhdGggZmlsbD0iI0FBQjdDNCIgZD0iTTIwLjkxNiAyMC4wMzJBMTEuOTcgMTEuOTcgMCAwIDEgMTIgMjRhMTEuOTcgMTEuOTcgMCAwIDEtOC45MTYtMy45NjhDNC4xNCAxOC4wNjQgNy43MzIgMTYuNjE1IDEyIDE2LjYxNWM0LjI2OCAwIDcuODYgMS40NDkgOC45MTYgMy40MTd6Ii8+PC9nPjwvZz48L3N2Zz4="
                    />
                  )}
                </a>
              </Dropdown>
            ) : (
              <Row type="flex" justify="end" gutter={10}>
                <Col className="hide-on-mobile">To get personalized news</Col>
                <Col>
                  <Button type="primary" size="small" onClick={navigateToAuth}>
                    Sign Up
                  </Button>
                </Col>
              </Row>
            )}
          </>
        </Col>
      </Row>
    </Header>
  );
};

export default TopNav;
